export class ChartData {
   data:any;
   label:any;
}
